export const DECIMAL_REGEX = /^(?!0\d)\d*(\.\d+)?$/;
